import * as Yup from 'yup';

export const postalCodes = Yup.array().min(
  1,
  'You need to choose at least 1 code',
);
